import { useState } from "react";
import { NewUser } from "../../../shared/src/types/User";
import { UserRole } from "@mekimix/shared/dist/types/User";
import Button from "../components/UI/Button";
import { CardSimple } from "../components/UI/Card";
import { useAddMentorMutation } from "../api/adminApi";
const AddMentorButton = () => {
  const [user, setUser] = useState<NewUser>({
    name: "",
    email: "",
    password_hash: "",
    role: UserRole.MENTOR,
    phone: "",
    active: true,
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [addMentor, { isLoading }] = useAddMentorMutation();
 const handleSubmit = async () => {
  if (!user.name || !user.email || !user.password_hash || !user.role) {
    setErrorMessage("יש למלא את כל שדות החובה כולל תפקיד");
    return;
  }
  try {
    const added = await addMentor(user).unwrap();
    console.log("Response from server:", added);
    setSuccessMessage(`המשתמש "${added.name || user.name}" נוסף בהצלחה`);
    setErrorMessage("");
  } catch (err: any) {
    console.error("שגיאה מהשרת:", err);
    setErrorMessage(err?.data?.error || "אירעה שגיאה בהוספה");
    setSuccessMessage("");
  }
};
  return (
    <CardSimple className="max-w-lg mx-auto space-y-4">
      <h2 className="text-xl font-semibold text-center text-primary">הוספת משתמש</h2>
      <input
        type="text"
        placeholder="שם"
        value={user.name}
        onChange={(e) => setUser({ ...user, name: e.target.value })}
        className="border border-border rounded-lg p-2 w-full"
      />
      <input
        type="email"
        placeholder="אימייל"
        value={user.email}
        onChange={(e) => setUser({ ...user, email: e.target.value })}
        className="border border-border rounded-lg p-2 w-full"
      />
      <input
        type="text"
        placeholder="סיסמה (מוצפנת)"
        value={user.password_hash}
        onChange={(e) => setUser({ ...user, password_hash: e.target.value })}
        className="border border-border rounded-lg p-2 w-full"
      />
      <select
        value={user.role}
        onChange={(e) => setUser({ ...user, role: e.target.value as UserRole })}
        className="border border-border rounded-lg p-2 w-full"
      >
        <option value="" disabled>בחר תפקיד</option>
        <option value={UserRole.MENTOR}>מלווה</option>
        <option value={UserRole.ADMIN}>מנהל</option>
      </select>
      <input
        type="text"
        placeholder="טלפון"
        value={user.phone || ""}
        onChange={(e) => setUser({ ...user, phone: e.target.value })}
        className="border border-border rounded-lg p-2 w-full"
      />
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={user.receive_emails || false}
          onChange={(e) => setUser({ ...user, receive_emails: e.target.checked })}
        />
        <span>האם לקבל מיילים?</span>
      </label>
      <Button onClick={handleSubmit} variant="primary-dark" fullWidth disabled={isLoading}>
        {isLoading ? "שולח..." : "הוסף משתמש"}
      </Button>
      {successMessage && <p className="text-green-600">{successMessage}</p>}
      {errorMessage && <p className="text-red-600">{errorMessage}</p>}
    </CardSimple>
  );
};
export default AddMentorButton;